import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'

import { v4 as rid } from 'uuid'
import { client, urlFor } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Skills.scss'

const Skills = () => {
  const [skills, setSkills] = useState([])

  useEffect(() => {
    const query = '*[_type == "skills"] | order(_updatedAt asc)'

    client.fetch(query).then(data => {
      setSkills(data)
    })
  }, [])

  return (
    <>
      <h2 className="head-text">
        Tech <span>Stack</span> <br />
      </h2>

      <div className="app__profiles">
        {skills.map((skill, index) => (
          <motion.div
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.5, type: 'tween', delay: index * 0.2 }}
            className="app__profile-item"
            key={`title_${rid()}`}>
            <img src={urlFor(skill.imgUrl)} alt={skill.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {skill.title}
            </h2>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(Skills, 'app__skills'), 'app__whitebg')
